import React, { useState } from 'react';
import '../../styles/footer.css';

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    
    try {
      const WEB3FORMS_ACCESS_KEY = "1ae60926-df33-4d9a-9b21-b72ef3b80dd8"; 

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          email: email,
          subject: "New Newsletter Subscriber - April Group",
          message: `You have a new subscriber for the April Group newsletter!\n\nEmail: ${email}`
        }),
      });

      const result = await response.json();
      
      if (result.success) {
        setStatus('success');
        setEmail('');
        setTimeout(() => setStatus(''), 4000);
      } else {
        console.error("Web3Forms Error:", result);
        setStatus('error');
        setTimeout(() => setStatus(''), 4000);
      }
    } catch (error) {
      console.error("Subscription Error:", error);
      setStatus('error');
      setTimeout(() => setStatus(''), 4000);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="php-email-form">
        <div className="newsletter-form">
          <input 
            type="email" 
            name="email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            disabled={status === 'loading'}
          />
          <input 
            type="submit" 
            value={status === 'loading' ? 'Subscribing...' : 'Subscribe'} 
            disabled={status === 'loading'} 
          />
        </div>
        {status === 'success' && (
          <div className="mt-2 text-success fw-bold" style={{ fontSize: '13px' }}>
            <i className="bi bi-check-circle me-1"></i>
            Thank you for subscribing to our newsletter!
          </div>
        )}
        {status === 'error' && (
          <div className="mt-2 text-danger fw-bold" style={{ fontSize: '13px' }}>
            <i className="bi bi-exclamation-circle me-1"></i>
            Oops! Something went wrong. Please try again.
          </div>
        )}
      </form>
    </div>
  );
};

export const TradingFooter = () => {
  return (
    <footer id="footer" className="footer dark-background">

      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="/" className="logo d-flex align-items-center">
              <div className="logo-badge">
                <img src="/img/aprilgroups-logo.jpeg" alt="April Groups Logo" className="img-fluid logo-img" />
                <span className="logo-tagline">PART OF APRIL GROUP</span>
              </div>
            </a>
            <div className="footer-contact pt-3">
              <p>Warehouse No 1</p>
              <p>Industrial Area 13</p>
              <p>Sharjah, U.A.E.</p>
              <div className="footer-contact-row mt-3">
                <strong>Phone :</strong>
                <span className="footer-contact-values">
                  <span>+97 1562 702486</span>
                  <span>+97 1565 508883</span>
                </span>
              </div>
              <div className="footer-contact-row">
                <strong>Email:</strong>
                <span className="footer-contact-values">
                  <span>hirshad@aprilgroups.com</span>
                  <span>nana@aprilpumps.com</span>
                </span>
              </div>
              <a href="https://Aprilfire.com" target="_blank" rel="noopener noreferrer"><span>www.Aprilfire.com</span></a>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="#"><i className="bi bi-twitter-x"></i></a>
              <a href="#"><i className="bi bi-facebook"></i></a>
              <a href="#"><i className="bi bi-instagram"></i></a>
              <a href="#"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Home</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">About us</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Services</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Terms of service</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Privacy policy</a></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Products</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Fire Alarm Systems</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Wireless Fire Alarms</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Emergency Light Systems</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Fire Cables</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Valves</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Sprinklers</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Foam Systems</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">FM200 Systems</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Pre Action Systems</a></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Connect & Updates</h4>
            <p>Subscribe to receive product updates, latest news, or to connect with our team!</p>
            <NewsletterForm />
          </div>

        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">AprilGroup</strong> <span>All Rights Reserved</span></p>
        <div className="credits">
        </div>
      </div>

    </footer>
  );
};

export const PumpsFooter = () => {
  return (
    <footer id="footer" className="footer dark-background">

      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="/" className="logo d-flex align-items-center">
              <div className="logo-badge">
                <img src="/img/aprilpumps-logo.png" alt="April Pumps Logo" className="img-fluid logo-img logo-pumps" />
                <span className="logo-tagline">PART OF APRIL GROUP</span>
              </div>
            </a>
            <div className="footer-contact pt-3">
              <p>Vake district, Tbilisi, Georgia</p>
              <p className="mt-3"><strong>Phone :</strong> <span className="ms-1">+995 595 858 883</span><br />
              </p>
              <p><strong>Email:</strong> <span>nana@aprilpumps.com</span></p>
              <a href="https://www.Aprilpumps.com" target="_blank" rel="noopener noreferrer"><span>www.Aprilpumps.com</span></a>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="#"><i className="bi bi-twitter-x"></i></a>
              <a href="#"><i className="bi bi-facebook"></i></a>
              <a href="#"><i className="bi bi-instagram"></i></a>
              <a href="#"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Home</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">About us</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Services</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Terms of service</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Privacy policy</a></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Pumps</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Horizontal End Suction</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Horizontal Split Case</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Vertical Turbine</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Sea Water Pumps</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Submersible Pumps</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Jockey Pumps</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Single Skid Pumps</a></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Connect & Updates</h4>
            <p>Subscribe to receive product updates, latest news, or to connect with our team!</p>
            <NewsletterForm />
          </div>

        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">AprilGroup</strong> <span>All Rights Reserved</span></p>
        <div className="credits">
        </div>
      </div>

    </footer>
  );
};

export const ControlPanelsFooter = () => {
  return (
    <footer id="footer" className="footer dark-background">

      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="/" className="logo d-flex align-items-center">
              <div className="logo-badge">
                <img src="/img/aprilpumps-logo.png" alt="April Pumps Logo" className="img-fluid logo-img logo-pumps" />
                <span className="logo-tagline">PART OF APRIL GROUP</span>
              </div>
            </a>
            <div className="footer-contact pt-3">
              <p>Warehouse No 1</p>
              <p>Industrial Area 13</p>
              <p>Sharjah, U.A.E.</p>
              <div className="footer-contact-row mt-3">
                <strong>Phone :</strong>
                <span className="footer-contact-values">
                  <span>+97 1565 508883</span>
                </span>
              </div>
              <div className="footer-contact-row">
                <strong>Email:</strong>
                <span className="footer-contact-values">
                  <span>nana@aprilpumps.com</span>
                </span>
              </div>
              <a href="https://www.Aprilpumps.com" target="_blank" rel="noopener noreferrer"><span>www.Aprilpumps.com</span></a>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="#"><i className="bi bi-twitter-x"></i></a>
              <a href="#"><i className="bi bi-facebook"></i></a>
              <a href="#"><i className="bi bi-instagram"></i></a>
              <a href="#"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Home</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">About us</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Services</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Terms of service</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#">Privacy policy</a></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Control Panels</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">UL LISTED JOCKEY CONTROLLERS</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">CUSTOM NON LISTED PUMP CONTROLLERS</a></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Connect & Updates</h4>
            <p>Subscribe to receive product updates, latest news, or to connect with our team!</p>
            <NewsletterForm />
          </div>

        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">AprilGroup</strong> <span>All Rights Reserved</span></p>
        <div className="credits">
        </div>
      </div>

    </footer>
  );
};

export const LandingFooter = () => {
  return (
    <footer id="footer" className="footer dark-background">

      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-6 col-md-12 footer-about">
            <a href="/" className="logo d-flex align-items-center mb-1">
              <img src="/img/aprilgroups-main-logo.png" alt="April Groups Logo" className="img-fluid landing-logo-img" />
            </a>
            <div className="footer-contact pt-1">
              <p>APRIL GROUP L.L.C</p>
              <p>Vake district, Tbilisi, Georgia</p>
              <p className="mt-3"><strong>Phone :</strong> <span className="ms-1">+995 595 858 883</span><br /> </p>
              <div className="footer-contact-row mt-3">
                <strong>Email:</strong>
                <span className="footer-contact-values">
                  <span>hirshad@aprilgroups.com</span>
                  <span>nana@aprilpumps.com</span>
                </span>
              </div>
              <a href="https://aprilgroups.com" target="_blank" rel="noopener noreferrer"><span>www.Aprilgroups.com</span></a>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="#"><i className="bi bi-twitter-x"></i></a>
              <a href="#"><i className="bi bi-facebook"></i></a>
              <a href="#"><i className="bi bi-instagram"></i></a>
              <a href="#"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">AprilGroup</strong> <span>All Rights Reserved</span></p>
        <div className="credits">
        </div>
      </div>

    </footer>
  );
};

const Footer = LandingFooter;
export default Footer;